<template>
  <section class="section">
    <div class="container content">
      <h1 class="title">{{ $t("menu.contact") }}</h1>
      <p>
        {{ $t("contact.comments") }}
        <EmailLink :email="$t('contact.authors.francisco.email')" />
      </p>
      <h2>{{ $t("contact.aboutAuthors") }}</h2>
      <MediaContact
        :name="$t('contact.authors.eduardo.name')"
        :email="$t('contact.authors.eduardo.email')"
        :image="$localized('photoESomarriba')"
      >
        {{ $t("contact.authors.eduardo.profile") }}
      </MediaContact>
      <MediaContact
        :name="$t('contact.authors.francisco.name')"
        :email="$t('contact.authors.francisco.email')"
        :image="$localized('photoFQuesada')"
      >
        {{ $t("contact.authors.francisco.profile") }}
      </MediaContact>
      <MediaContact
        :name="$t('contact.authors.jose.name')"
        :email="$t('contact.authors.jose.email')"
        :image="$localized('photoJBarrantes')"
      >
        {{ $t("contact.authors.jose.profile") }}
      </MediaContact>
      <MediaContact
        :name="$t('contact.authors.randall.name')"
        :email="$t('contact.authors.randall.email')"
        :image="$localized('photoRZamora')"
      >
        {{ $t("contact.authors.randall.profile") }}
        <a
          href="https://www.luzmax.com"
          target="_blank"
          :title="luzmaxDescription"
          >{{ $t("contact.luzmax") }}</a
        >
      </MediaContact>
      <MediaContact
        :name="$t('contact.authors.matthias.name')"
        :email="$t('contact.authors.matthias.email')"
        :image="$localized('photoMMalek')"
      >
        {{ $t("contact.authors.matthias.profile") }}
      </MediaContact>
      <MediaContact
        :name="$t('contact.authors.eduardoV.name')"
        :email="$t('contact.authors.eduardoV.email')"
        :image="$localized('photoEVargas')"
      >
        {{ $t("contact.authors.eduardoV.profile") }}
      </MediaContact>
      <MediaContact
        :name="$t('contact.authors.fergus.name')"
        :email="$t('contact.authors.fergus.email')"
        :image="$localized('photoFSinclair')"
      >
        {{ $t("contact.authors.fergus.profile") }}
      </MediaContact>
      <h2 class="title is-3">{{ $t("contact.development") }}</h2>
      <p>
        {{ $t("contact.developedBy") }}
        <a
          href="https://www.luzmax.com"
          target="_blank"
          class="has-text-weight-semibold"
          :title="luzmaxDescription"
          >Luzmax</a
        >
      </p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.spaced {
  list-style-type: none;
  margin-left: 0;

  li {
    margin-top: 1rem;
    margin-bottom: 1.5rem;
  }
}
</style>

<script>
import MediaContact from "@/components/MediaContact.vue";
import EmailLink from "@/components/EmailLink.vue";

export default {
  components: {
    MediaContact,
    EmailLink
  },
  data() {
    return {
      luzmaxDescription: this.$i18n.t("contact.luzmaxDescription")
    };
  }
};
</script>
